import React from "react";
// import { lazy, Suspense, useEffect, useState } from "react";
// import { REMOTE_ENTRIES_CONFIG } from "@qubictron/microfrontend";
// import { ErrorBoundary } from "react-error-boundary";
// import { MicrofrontendInstanceManager } from "shared/lib/mf.lib";
import { useAppDispatch } from "shared/lib/redux";

// import { localization } from "shared/localization/localization";
// import { Portal } from "shared/ui/Portal";
// import { AppDOM } from "shared/utils/app.utils";
// import { isQubictronDomain } from "shared/utils/url.utils";
// import styles from "./AuthModal.module.scss";
import { authStore } from "../model/auth.store";

// type AuthSystemProps = {
//   lang?: string;
//   clientsInfo: {
//     initSettings: {
//       appName: string;
//     };
//     httpReferer: string;
//     clients?: {
//       redirect_uri: string;
//       client_id: number;
//     };
//     popup: boolean;
//     class?: string;
//     urlFacebook: string;
//     urlGoogle: string;
//     urlApple: string;
//   };
// };

// type AuthSystemComponent = React.ComponentType<AuthSystemProps>;

type AuthModalProps = {
  authData: {
    urlFacebook: string;
    urlGoogle: string;
    urlApple: string;
  };
  platform: number;
};

/**
 * Auth modal via microfrontend is disabled (no @qubictron/microfrontend package).
 * Keep the component export so call sites still type-check.
 */
export const AuthModal: RFC<AuthModalProps> = ({ authData: _authData, platform: _platform }) => {
  const dispatch = useAppDispatch();

  // Close modal if somehow opened while MF auth is disabled.
  React.useEffect(() => {
    dispatch(authStore.actions.setIsAuthModalVisibleAction(false));
  }, [dispatch]);

  return null;

  // Original MF auth remote load:
  // const [AuthSystem, setAuthSystem] = useState<AuthSystemComponent | null>(() => null);
  // const mainContainerHeight = AppDOM.appContainer.offsetHeight - 60;
  // const onClose = () => {
  //   dispatch(authStore.actions.setIsAuthModalVisibleAction(false));
  // };
  // useEffect(() => {
  //   setAuthSystem(() =>
  //     lazy<AuthSystemComponent>(() => {
  //       if (!MicrofrontendInstanceManager.instance) return Promise.resolve({ default: () => null });
  //       return MicrofrontendInstanceManager.instance.loadRemote<AuthSystemProps>({
  //         moduleName: REMOTE_ENTRIES_CONFIG.auth_system.name,
  //         componentName: REMOTE_ENTRIES_CONFIG.auth_system.components.App,
  //       });
  //     })
  //   );
  // }, []);
  // return (
  //   !!AuthSystem && (
  //     <Portal className={styles.modal} closePopup={onClose}>
  //       <ErrorBoundary fallback={<div>Error loading remote auth system</div>}>
  //         <Suspense>
  //           <div className={styles.authContainer} style={{ maxHeight: mainContainerHeight }}>
  //             <AuthSystem ... />
  //           </div>
  //         </Suspense>
  //       </ErrorBoundary>
  //     </Portal>
  //   )
  // );
};
